/**
 * @generated SignedSource<<d5dfbb489550bfd34af1057374f598ea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorByLineFragment_query$data = Result<{
  readonly contentContributors: {
    readonly count: number | null;
    readonly isOwnerContributor: boolean | null;
  } | null;
  readonly " $fragmentType": "useEditorByLineFragment_query";
}, unknown>;
export type useEditorByLineFragment_query$key = {
  readonly " $data"?: useEditorByLineFragment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorByLineFragment_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorByLineFragment_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "contentId"
        },
        {
          "kind": "Literal",
          "name": "limit",
          "value": 4
        }
      ],
      "concreteType": "ContentContributors",
      "kind": "LinkedField",
      "name": "contentContributors",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "isOwnerContributor"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "73017b75548dbaab6bf46845d75f569d";

export default node;
